import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';
import { IEventLight } from '../../Models';

interface IEventPromotedProps {
    allEventLink: string;
    dictSeeAllEvent: string;
    dictEventDescription: string;
    dictAgenda: string;
}

interface IEventPromotedWidgetState {
    events: IEventLight[];
}

export class EventPromotedWidget extends Component<
    IEventPromotedProps,
    IEventPromotedWidgetState
> {
    constructor(props: any) {
        super(props);

        this.state = {
            events: [],
        };
    }

    render() {
        return (
            <div className="bloc-agenda">
                <div className="bloc-agenda__image">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="100"
                        height="87.599"
                    >
                        <g transform="translate(2 2.402)">
                            <rect
                                className="a"
                                width="9"
                                height="20"
                                rx="4.5"
                                transform="translate(25.999 -.402)"
                            />
                            <rect
                                className="a"
                                width="9"
                                height="20"
                                rx="4.5"
                                transform="translate(60.999 -.402)"
                            />
                            <path
                                className="a"
                                d="M80.001 9.6h16v73.6h-96V9.6h16M44.999 9.598h6M73.998 51.598h-52M73.998 63.598h-52"
                            />
                        </g>
                        <path className="a" d="M2 34h96" />
                    </svg>
                </div>
                <div className="bloc-agenda__content">
                    <h2 className="title">{this.props.dictAgenda}</h2>

                    <p>{this.props.dictEventDescription}</p>
                    <a href={this.props.allEventLink} className="btn-primary">
                        {this.props.dictSeeAllEvent}
                    </a>
                </div>
            </div>
        );
    }
}

WidgetHelper.register(EventPromotedWidget, 'event-promoted-widget');
